import React, { Component, useEffect, useState } from "react";
import AddNewTimeLog from "./AddNewTimeLog";
import Moment from "react-moment";
import AddEditNotes from "./AddEditNotes";
import CandidatePay from "./CandidatePay";
import {
  formatTotalHours,
  getFieldData,
  getMonthLastDay,
  getMonthName,
  getTotalDays,
  getTotalHours,
} from "../../Services/appService";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTimeSheetDoc,
  getProjectDateUpdateStatus,
  getTimeLogDuration,
  getTimeLogs,
  getTimeSheetDelStatus,
  loadTimeLogDuration,
  loadTimeLogs,
  updateProjectStartDate,
} from "../../app/store/timeLog";
import {
  getTimeLogInvoice,
  loadTimeLogInvoice,
} from "../../app/store/timeLogInvoice";
import useDocDownload from "../../app/hooks/useDocDownload";
import RateEncryptDecrypt from "../../Services/RateEncryptDecrypt";
import { getCandidateAppAllTasks } from "../../app/store/candidate";

export default function TimeLogs() {
  const usrType = localStorage.getItem("userType");

  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [timeLogs, setTimeLogs] = useState([]);
  const [invType, setInvType] = useState("subcontractor");
  const [entityType, setEntityType] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [notesType, setNotesType] = useState(
    usrType === "recruiter" ? "TimeLogRecruiter" : "TimeLog"
  );
  const [showHide, setShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [showHideTimeLog, setShowHideTimeLog] = useState(false);
  const [timeLogObj, setTimeLogObj] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [appAllTasks, setAllAppTasks] = useState([]);

  const timeLogsSelector = useSelector(getTimeLogs);
  const timeLogInvoiceSelector = useSelector(getTimeLogInvoice);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const updateStatusSelector = useSelector(getProjectDateUpdateStatus);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const timeSheetDelStatusSelector = useSelector(getTimeSheetDelStatus);
  const candidateAppAllTasksSelector = useSelector(getCandidateAppAllTasks);

  const [handleDownloadFile] = useDocDownload();

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userDetailsSelector) {
      dispatch(loadUserDetails(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (userDetailsSelector) {
      const cnObj = userDetailsSelector;
      const entityType = getFieldData(
        cnObj.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      setCandidateObj(cnObj);
      setEntityType(entityType);
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setAllAppTasks(candidateAppAllTasksSelector);
  }, [candidateAppAllTasksSelector]);

  useEffect(() => {
    if (currentUser?.id && entityType) {
      dispatch(loadTimeLogs(currentUser.id));
      dispatch(loadTimeLogInvoice(currentUser.id));
      dispatch(loadTimeLogDuration(currentUser.id));
    }
  }, [entityType]);

  useEffect(() => {
    if (timeLogsSelector.length > 0) setTimeLogs(timeLogsSelector);
    if (timeLogInvoiceSelector.length > 0) {
      let invoType = invType;
      if (usrType === "candidate") invoType = usrType;
      if (usrType === "candidate" && entityType === "C2C Basis")
        invoType = "subcontractor";
      const filterInvoices = timeLogInvoiceSelector.filter(
        (x) => x.invoiceType === invoType
      );
      setTimeLogInvoices(filterInvoices);
    }
    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate()); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      console.log(result);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogsSelector, timeLogInvoiceSelector, timeLogDurationSelector]);

  useEffect(() => {
    if (updateStatusSelector) {
      getAlert("", "Saved Successfully", "success");
      dispatch(loadTimeLogDuration(currentUser.id));
    }
  }, [updateStatusSelector]);

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.status !== null
    );
    if (tmLogs.length === 0) {
      return <span>Review Pending</span>;
    }

    return (
      <>
        {tmLogs.map((inv) => (
          <React.Fragment>
            <span>Reviewed</span>
            <br />
            {inv.status === true && <span>Approved</span>}
            {inv.status === false && <span>Rejected</span>}
            <br />
            <Moment format="MMM Do YYYY">{inv.reviewDateTime}</Moment>
          </React.Fragment>
        ))}
      </>
    );
  };

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter((x) => x.timeLogId === item.id);

    if (tmLogs.length === 0) return "";
    return (
      <>
        {tmLogs.map((pay) => (
          <React.Fragment>
            {pay.paymentMode && (
              <>
                {pay.docList?.map((doc) => (
                  <button
                    className="btn btn-sm btn-link p-0 text-underline"
                    onClick={() => handleDownloadFile(doc)}
                  >
                    {doc.documentName}
                  </button>
                ))}
                {pay.docList?.length > 0 && <br />}
                <Moment format="MMM Do YYYY, h:mm a">{pay.paymentDate}</Moment>
                {entityType === "W2 Basis" && (
                  <>
                    <br />
                    {/* Deduction: {parseFloat(pay.adpDeduction || 0).toFixed(2)} */}
                    Deduction:{" "}
                    {pay?.adpDeduction ? (
                      <RateEncryptDecrypt rateData={pay.adpDeduction} />
                    ) : (
                      "$0.00/Hr"
                    )}
                  </>
                )}
                <br />
                {/* Paid : {parseFloat(pay.paidAmount).toFixed(2)} */}
                Paid :{" "}
                {pay?.paidAmount ? (
                  <RateEncryptDecrypt rateData={pay.paidAmount} />
                ) : (
                  "$0.00/Hr"
                )}
              </>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };

  const getPerDiemStatus = (item) => {
    const prd = getFieldData(
      candidateObj?.performerData,
      "candidateonboardingform",
      "Per_Diem_Rate"
    );
    return (
      <>
        {/* {prd} */}
        {prd ? <RateEncryptDecrypt rateData={prd} /> : ""}
        <br />
        {/* {prd * getTotalDays(item.workingHrs)} */}
        {prd ? (
          <RateEncryptDecrypt rateData={prd * getTotalDays(item.workingHrs)} />
        ) : (
          ""
        )}
      </>
    );
  };

  const getTimeLogStatus = (item) => {
    const invoices = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id
    );

    const hasPaidAmount = invoices.some((x) => x.paidAmount > 0);
    const hasApprovedInvoice = invoices.some((x) => x.status === true);

    // No payment recorded yet → editable
    if (!hasPaidAmount) {
      return (
        <button
          type="button"
          className="btn btn-sm btn-link p-0"
          onClick={() => handleShowHide(item)}
        >
          Edit
        </button>
      );
    }

    // Payment exists but not approved → still editable (highlighted)
    if (!hasApprovedInvoice) {
      return (
        <button
          type="button"
          className="btn btn-sm btn-link p-0 text-underline"
          onClick={() => handleShowHide(item)}
        >
          Edit
        </button>
      );
    }

    // Approved & paid → no action
    return null;
  };


  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <div>
        <Moment format="MM/DD/YYYY">{first.start}</Moment>
        {" - "}
        <Moment format="MM/DD/YYYY">{lastDate}</Moment>
      </div>
    );
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setTimeLogObj(null);
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handlePayShowHide = (obj) => {
    setPayShowHide(!payShowHide);
    setTimeLogObj(obj);
  };

  const handleSaveProjectStartDate = () => {
    dispatch(updateProjectStartDate(currentUser.id, projectStartDate));
  };

  const handleStartDate = ({ currentTarget }) => {
    setProjectStartDate(currentTarget.value);
  };

  const handleShowHide = (obj) => {
    if (obj === "save") {
      setTimeLogObj("");
      setShowHide(false);
      dispatch(loadTimeLogs(currentUser.id));
    } else {
      setShowHide(!showHide);
      setTimeLogObj(obj);
    }
  };

  const handleDeleteTimeSheetDoc = async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to delete this Time Sheet?",
      "warning"
    );
    if (result.isConfirmed) {
      dispatch(deleteTimeSheetDoc(id));
    }
  };

  useEffect(() => {
    if (timeSheetDelStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      dispatch(loadTimeLogs(currentUser.id));
    }
  }, [timeSheetDelStatusSelector]);

  let startDt = projectStartDate;
  if (startDt === "") startDt = new Date();
  let pgTitle = "Time Log Management";
  if (entityType !== "C2C Basis") pgTitle = "Time Log and Payments";

  return (
    <React.Fragment>
      <div className="col-md-12 mt-2">
        {/* <li className="list-group-item p-2 mb-2">
          <p className="text-black">
            Enter your daily hours logged for each week and upload the
            completed /signed time sheets. Once you enter the hours and upload
            the time sheet all entities as applicable (except the Agency at
            which you are working) will see it in real-time, and this includes
            your employers/subcontractors, if any.
          </p>
          <p className="text-black mt-2">
            Please ensure to log hours and upload time sheets on time to avoid
            any delays in raising invoices to the Agencies.
          </p>
        </li> */}
        <div className="card shadow-none border">
          <div className="card-header p-3">
            <div className="row">
              <div className="col-md-4">
                {/* <i className="fa fa-square wf-phase6-box mr-2" aria-hidden="true"></i> */}
                <span className="h3">{pgTitle}</span>
              </div>
              <div className="col-md-8 text-right">
                <button
                  className="btn btn-sm btn-outline-default"
                  disabled={
                    appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                      .length === 0
                  }
                  onClick={() => handleShowHide("")}
                >
                  <i class="fa fa-plus" aria-hidden="true"></i> Add Time Log
                </button>
              </div>
            </div>
          </div>
          <div className="card-body p-3">
            <div className="form-inline mb-2">
              <label htmlFor="">Date started on the project</label>
              {projectStDt !== "" ? (
                <>
                  <input
                    type="text"
                    className="form-control form-control-sm ml-2 mr-2"
                    disabled="true"
                    value={new Date(projectStDt).toISOString().substring(0, 10)}
                  />
                  <button
                    className="btn btn-sm btn-outline-default"
                    disabled={
                      appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                        .length === 0
                    }
                    onClick={() => setProjectStDt("")}
                  >
                    <i className="fa fa-edit" aria-hidden="true"></i> Edit
                  </button>
                </>
              ) : (
                <>
                  <input
                    type="date"
                    className="form-control form-control-sm ml-2 mr-2"
                    value={new Date(startDt).toISOString().substring(0, 10)}
                    onChange={handleStartDate}
                  />
                  <button
                    className="btn btn-sm btn-outline-default"
                    onClick={handleSaveProjectStartDate}
                  >
                    <i className="fa fa-check" aria-hidden="true"></i> Save
                  </button>
                  <button
                    className="btn btn-sm btn-outline-default"
                    onClick={() => setProjectStDt(currentStDt)}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </>
              )}
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-flush align-items-center mb-2 border">
                <thead className="thead-light">
                  <tr>
                    <th>Year</th>
                    <th>Month</th>
                    <th>
                      Period
                      <br />
                      <span>Time Logged</span>
                    </th>
                    <th>
                      Total Hours
                      <br />
                      <span>Total Days</span>
                    </th>
                    <th>
                      Approved
                      <br />
                      <span>Timesheets</span>
                    </th>

                    {entityType !== "W2 Basis" && <th>Status</th>}

                    <th>
                      Notes
                      <br />
                      <span>from IPCS</span>
                    </th>

                    {(entityType === "W2 Basis" || entityType !== "C2C Basis") && (
                      <th>
                        Payment Date & Time
                        <br />
                        {entityType === "W2 Basis" && <span>Deduction ($)</span>}
                        <br />
                        <span>Payment ($)</span>
                      </th>
                    )}

                    {entityType === "W2 Basis" && (
                      <th>
                        Per Diem
                        <br />
                        <span>Rate / Amount ($)</span>
                      </th>
                    )}

                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {timeLogs.map((item) => (
                    <tr key={item.id}>
                      <td>{item.year}</td>
                      <td>{getMonthName(item.month)}</td>

                      <td>
                        {getMonthlyPeriod(item)}
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0 ml-1"
                          onClick={() => handleShowHide(item)}
                        >
                          View
                        </button>
                      </td>

                      <td>
                        <i className="fa fa-clock-o mr-1" />
                        {formatTotalHours(item?.workingHrs)}
                        <br />
                        {getTotalDays(item.workingHrs)}{" "}
                        {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                      </td>

                      {/* Approved Timesheets */}
                      <td>
                        <ul className="list-unstyled mb-0">
                          {item.docList?.map((doc) => {
                            const isLocked = timeLogInvoices.some(
                              (x) => x.timeLogId === item.id && x.status === true
                            );

                            return (
                              <li
                                key={doc.id}
                                className="d-flex justify-content-between align-items-center"
                              >
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm p-0 text-left"
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.documentName}
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-sm"
                                  title="Delete Timesheet"
                                  disabled={isLocked}
                                  onClick={() => handleDeleteTimeSheetDoc(doc.id)}
                                >
                                  <i className="fa fa-trash text-dark" />
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </td>

                      {entityType !== "W2 Basis" && (
                        <td>{getInvoiceStatus(item)}</td>
                      )}

                      {/* Notes */}
                      <td>
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0"
                          onClick={() => handleNotesComments("", item)}
                        >
                          View
                          <span className="badge badge-pill badge-success ml-1 text-dark">
                            {
                              item?.allComments?.filter(
                                (x) => x.commentType === notesType
                              ).length
                            }
                          </span>
                        </button>
                      </td>

                      {entityType !== "C2C Basis" && (
                        <td>{getPaymentStatus(item)}</td>
                      )}

                      {entityType === "W2 Basis" && (
                        <td>{getPerDiemStatus(item)}</td>
                      )}

                      <td>{getTimeLogStatus(item)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

      <AddNewTimeLog
        showHide={showHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        timeLogInvoices={timeLogInvoices}
        allTimeLogs={timeLogsSelector}
        candidateObj={candidateObj}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNotesComments}
        notesType={notesType}
        candidateObj={candidateObj}
        timeLogObj={timeLogObj}
      ></AddEditNotes>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        selectedObj={timeLogObj}
        candidateObj={candidateObj}
      ></CandidatePay>

      {/* <AddTimeLog
        showHideTimeLog={showHideTimeLog}
        handleShowHideTimeLog={handleShowHideTimeLog}
        appTasklist={appTasklist}
        workflowTask={workflowTask}
      ></AddTimeLog> */}
    </React.Fragment>
  );
}
